import { render, staticRenderFns } from "./agree.vue?vue&type=template&id=6c7fa25c&scoped=true&"
import script from "./agree.vue?vue&type=script&lang=js&"
export * from "./agree.vue?vue&type=script&lang=js&"
import style0 from "./agree.vue?vue&type=style&index=0&id=6c7fa25c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7fa25c",
  null
  
)

export default component.exports